export default function MapsDirect() {
  return (
    <div className="w-full flex justify-center  items-center">
      <iframe
        title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15113.976758238701!2d76.3720592871582!3d18.731450300000006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc55f18a280968d%3A0xb50f4cf1a8624328!2sKing%20Fitness%20Center!5e0!3m2!1sen!2sin!4v1724785935018!5m2!1sen!2sin"
        width="600"
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}
